<template>
  <a-row type="flex" :gutter="15" style="flex-wrap: nowrap;z-index: 9999999;">
    <a-col :flex="labelWidth">
      <div class="myformlabel" :style="labelStyle">{{ label }}</div>
    </a-col>
    <a-col flex="auto">
      <slot></slot>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: String,
      default: "96px",
    },
    placeholder: {
      type: String,
      default: "",
    },
    labelStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      value: "",
    };
  },
};
</script>

<style scoped>
.myformlabel {
  text-align: right;
  line-height: 20px;
  /* border: 1px solid red; */
  font-size: 14px;
  font-weight: bold;
  color: #4b596a;
  /* height: 100%; */
  min-height: 38px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
</style>